export const isIpfsUri = (uri?: string) => {
  if (uri === undefined) {
    return '';
  }

  return uri?.startsWith('ipfs://')||uri?.startsWith('https://ipfs.io')||uri?.startsWith('https://alchemy.mypinata.cloud')||uri?.startsWith('https://cloudflare-ipfs.com')||uri?.startsWith('https://4everland.io');
};

export const ipfsUriToUrl = (uri: string) => {
  const ipfsgatewayurl = process.env.REACT_APP_IPFS_GATEWAY_BASEURL!;
  if (!isIpfsUri(uri)) {
    return uri;
  } 
  if (uri === '' || uri === undefined || uri === null) {
    return '';
  }
  if (uri?.startsWith('https://ipfs.io')) {
    return uri.replace('https://ipfs.io', ipfsgatewayurl);
  }
  if (uri?.startsWith('https://alchemy.mypinata.cloud')) {
    return uri.replace('https://alchemy.mypinata.cloud', ipfsgatewayurl);
  }
  if (uri?.startsWith('https://cloudflare-ipfs.com')) {
    return uri.replace('https://cloudflare-ipfs.com', ipfsgatewayurl);
  }
  if (uri?.startsWith('https://4everland.io')) {
    return uri.replace('https://4everland.io', ipfsgatewayurl);
  }

  return uri.replace('ipfs://', ipfsgatewayurl+'/ipfs/');
};
